import type { CostEstimate, CostGate } from '../types/cost-estimate.types';

/** A run held at the cost gate: when it paused and which estimate to link to. */
export interface CostWaiting {
  /** ISO time the run paused; null when the source did not say. */
  waitingSince: string | null;
  /** Workflow id the estimate details page is keyed on. */
  workflowId: string;
}

/**
 * Whether a run is paused at the cost gate. A loaded estimate is the freshest signal on pages
 * that fetch it (a decision writes it immediately), so it wins; without one the run API's
 * `costGate` decides. Null = not waiting (or not known to be).
 */
export function resolveCostWaiting(
  costGate: CostGate | null | undefined,
  estimate: CostEstimate | null | undefined,
): CostWaiting | null {
  if (estimate) {
    return estimate.status === 'PENDING_APPROVAL'
      ? { waitingSince: estimate.createdAt, workflowId: estimate.workflowId }
      : null;
  }
  if (costGate) return { waitingSince: costGate.waitingSince, workflowId: costGate.workflowId };
  return null;
}
